<app-loading *ngIf="contentReady"></app-loading>

<div class="bb-page">
  <div class="bb-page-shell">
    <div class="bb-page-header">
      <div class="bb-page-title-block">
                                 <span class="bb-eyebrow">{{ 'products' | transloco }}</span>
        <h2 class="bb-page-title">{{ "products" | transloco }}</h2>
        <p class="bb-page-subtitle">{{ "manage inventory" | transloco }}</p>
      </div>

      <div class="bb-header-actions">
        @if(!isStockTaking){

        @if(isAdmin || isSubAdmin){
        <button routerLink="/AddItem" class="bb-btn bb-btn-primary">
          {{ "add stock" | transloco }}
        </button>
        }

        @if(warehouseTypeService.isClinic() || warehouseTypeService.isShopAndClinic()){
        <button routerLink="/AllServices" class="bb-btn bb-btn-secondary">
          {{ "all services" | transloco }}
        </button>
        }

        @if(isAdmin && warehouseTypeService.isBlueBoxMain){
        <button routerLink="/bundles" class="bb-btn bb-btn-secondary">
          {{ "bundles" | transloco }}
        </button>
        }

        @if(isAdmin){
        <button routerLink="/brands" class="bb-btn bb-btn-secondary">
          {{ "brands" | transloco }}
        </button>
        }

        @if(!noData){
        <button (click)="stockTaking()" class="bb-btn bb-btn-secondary">
          {{ "stockTaking" | transloco }}
        </button>
        }

        @if(!noData && !isSubAdmin){
        <button (click)="resetPagination();getwarehouseBytopSale(1)" class="bb-btn bb-btn-secondary">
          {{ "mostSales" | transloco }}
        </button>
        }

        }
      </div>
    </div>

    <div class="bb-filter-card">
      <div class="search-row">
        <div class="search-box">
          <input type="text" class="bb-input" [(ngModel)]="searchKey" placeholder="{{ 'item name' | transloco }}"
            (keydown.enter)="onEnterPressed()">

          <button class="bb-btn bb-btn-primary" (click)="search()">
            {{ "Search" | transloco }}
          </button>

          <button *ngIf="searched" class="bb-btn bb-btn-secondary" (click)="clearSearch()" type="button">
            {{ "all data" | transloco }}
          </button>
        </div>

        @if(warehouseTypeService.isCompany()){
        <button *ngIf="!noData" routerLink="/homegridview" class="bb-btn bb-btn-secondary">
          {{ "list view" | transloco }}
        </button>
        }
      </div>

      <div *ngIf="cartItemCount > 0" class="bb-floating-cart" (click)="cartPopUpOpen()">
        <span class="bb-floating-cart-count">{{ cartItemCount }}</span>
        <i class="fa-solid fa-cart-shopping"></i>
        {{ "Cart" | transloco }}
      </div>
    </div>

    <div class="bb-table-card">
      <div class="bb-table-scroll">
        <table mat-table id="stocktable" [dataSource]="dataSource" class="bb-table">

          <!-- Name EN Column -->
          <ng-container matColumnDef="name_en">
            <th mat-header-cell *matHeaderCellDef>{{ "Name" | transloco }}</th>
            <td mat-cell *matCellDef="let element">
              <div class="bb-flex bb-items-center bb-gap-12">
                @if(element.image != null) {
                <span class="bb-product-img-box">
                  <img [src]="fixImage(element.image)">
                </span>
                }
                <span class="bb-text-stack">
                  <span class="bb-product-title">{{element.name_en}}</span>
                  <small>{{element.barcode}}</small>
                </span>
              </div>
            </td>
          </ng-container>

          <!-- Name AR Column -->
          <ng-container matColumnDef="name_ar">
            <th mat-header-cell *matHeaderCellDef>{{ "NameAr" | transloco }}</th>
            <td mat-cell *matCellDef="let element">
              <div class="bb-flex bb-items-center bb-gap-12">
                @if(element.image != null) {
                <span class="bb-product-img-box">
                  <img [src]="fixImage(element.image)">
                </span>
                }
                <span class="bb-text-stack">
                  <span class="bb-product-title">{{element.name_ar}}</span>
                  <small>{{element.barcode}}</small>
                </span>
              </div>
            </td>
          </ng-container>

          <!-- Category Column -->
          <ng-container matColumnDef="category_id">
            <th mat-header-cell *matHeaderCellDef>{{ "Category" | transloco }}</th>
            <td mat-cell *matCellDef="let element">
              {{ getCategoryName(element.category_id) | transloco }}
            </td>
          </ng-container>

          <!-- Weight Column -->
          <ng-container matColumnDef="weight">
            <th mat-header-cell *matHeaderCellDef>{{ "weight" | transloco }}</th>
            <td mat-cell *matCellDef="let element"> {{element.weight}} </td>
          </ng-container>

          <!-- Quantity Column -->
          <ng-container matColumnDef="quantity">
            <th mat-header-cell *matHeaderCellDef>{{ "quantity" | transloco }}</th>
            <td mat-cell *matCellDef="let element">
              @if(element.quantity == 0) {
              <span class="bb-text-danger bb-font-bold">{{ "out of stock" | transloco }}</span>
              } @else {
              @if(isLowStock(element.quantity)) {
              @if(isAdmin || isSubAdmin) {
              <span class="bb-text-danger bb-font-bold">{{element.quantity}}</span>
              } @else {
              <span>{{element.quantity}}</span>
              }
              } @else {
              <span>{{element.quantity}}</span>
              }
              }
            </td>
          </ng-container>

          <!-- Pet Type Column -->
          <ng-container matColumnDef="pet_type">
            <th mat-header-cell *matHeaderCellDef>{{ "pet type" | transloco }}</th>
            <td mat-cell *matCellDef="let element">
              {{ getPetTypeName(element.pet_type) | transloco }}
            </td>
          </ng-container>

          <!-- Pet Column -->
          <ng-container matColumnDef="type">
            <th mat-header-cell *matHeaderCellDef>{{ "pet" | transloco }}</th>
            <td mat-cell *matCellDef="let element">
              {{ getPetName(element.pet) | transloco }}
            </td>
          </ng-container>

          <!-- Expiration Column -->
          <ng-container matColumnDef="expiration_data">
            <th mat-header-cell *matHeaderCellDef>{{ "expiration" | transloco }}</th>
            <td mat-cell *matCellDef="let element">
              @if((isAdmin || isSubAdmin) && isExpiringSoon(element.expiration_data)) {
              <span class="bb-text-danger bb-font-bold">
                {{ formatDate(element.expiration_data) }}
              </span>
              } @else {
              <span>{{ formatDate(element.expiration_data) }}</span>
              }
            </td>
          </ng-container>

          <!-- Most Sales Column -->
          <ng-container matColumnDef="mostSales">
            <th mat-header-cell *matHeaderCellDef>{{ "mostSales" | transloco }}</th>
            <td mat-cell *matCellDef="let element">
              <span class="bb-badge bb-badge-soft-blue bb-uppercase">
                {{element.order_count}} {{"times" | transloco}}
              </span>
            </td>
          </ng-container>

          <!-- Price Column -->
          <ng-container matColumnDef="price">
            <th mat-header-cell *matHeaderCellDef>
              {{ getPriceColumnHeader('price') | transloco }}
            </th>
            <td mat-cell *matCellDef="let element" class="bb-price"> {{ element.price | number:'1.0-2' }}
            </td>
          </ng-container>

          <!-- Affiliation Price Column -->
          <ng-container matColumnDef="affiliationprice">
            <th mat-header-cell *matHeaderCellDef>
              {{ getPriceColumnHeader('affiliationprice') | transloco }}
            </th>
            <td mat-cell *matCellDef="let element" class="bb-price"> {{element.affiliationprice |
              number:'1.0-2'}} </td>
          </ng-container>

          <!-- Price A Column -->
          <ng-container matColumnDef="pricea">
            <th mat-header-cell *matHeaderCellDef>
              {{ getPriceColumnHeader('pricea') | transloco }}
            </th>
            <td mat-cell *matCellDef="let element" class="bb-price"> {{element.pricea | number:'1.0-2'}}
            </td>
          </ng-container>

          <!-- Price B Column -->
          <ng-container matColumnDef="priceb">
            <th mat-header-cell *matHeaderCellDef>
              {{ getPriceColumnHeader('priceb') | transloco }}
            </th>
            <td mat-cell *matCellDef="let element" class="bb-price"> {{element.priceb | number:'1.0-2'}}
            </td>
          </ng-container>

          <!-- Price C Column -->
          <ng-container matColumnDef="pricec">
            <th mat-header-cell *matHeaderCellDef>
              {{ getPriceColumnHeader('pricec') | transloco }}
            </th>
            <td mat-cell *matCellDef="let element" class="bb-price"> {{element.pricec | number:'1.0-2'}}
            </td>
          </ng-container>

          <!-- Actions Column -->
          <ng-container matColumnDef="delete">
            <th mat-header-cell *matHeaderCellDef class="bb-actions-th"></th>
            <td mat-cell *matCellDef="let element" class="bb-actions-td">
              @if(isSubAdmin) {
              <button
                class="bb-icon-btn action-btn cart"
                type="button"
                [class.active]="isInCart(element)"
                (click)="addToCart(element)"
                [title]="isInCart(element) ? ('remove from cart' | transloco) : ('add or remove from cart' | transloco)"
              >
                <i
                  class="fa-solid"
                  [class.fa-cart-plus]="!isInCart(element)"
                  [class.fa-trash-can]="isInCart(element)"
                ></i>
              </button>
              } @else {
              <div class="dropdown bb-action-dropdown">
                <button class="bb-icon-btn action-btn menu" type="button" data-bs-toggle="dropdown" aria-expanded="false"
                  title="{{ 'Actions' | transloco }}">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                    <circle cx="12" cy="5" r="2" />
                    <circle cx="12" cy="12" r="2" />
                    <circle cx="12" cy="19" r="2" />
                  </svg>
                </button>
                <ul class="dropdown-menu dropdown-menu-end bb-dropdown-menu" aria-labelledby="dropdownMenuButton1">
                  <li>
                    <a class="dropdown-item bb-dropdown-item" (click)='addToCart(element)'>
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                        stroke-width="2">
                        <circle cx="9" cy="21" r="1" />
                        <circle cx="20" cy="21" r="1" />
                        <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6" />
                      </svg>
                      {{ "add or remove from cart" | transloco }}
                    </a>
                  </li>

                  @if(isSubAdmin || isAdmin) {
                  <li *ngIf="warehouseTypeService.isBlueBoxMain">
                    <a class="dropdown-item bb-dropdown-item" (click)="toggleOffer(element.id)">
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                        stroke-width="2">
                        <path
                          d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
                      </svg>
                      {{ element.is_daily_offer ? ('Remove Daily Offer' | transloco) : ('Make Daily Offer' |
                      transloco) }}
                    </a>
                  </li>
                  @if(!hasSingleWarehouse) {
                  <li>
                    <a class="dropdown-item bb-dropdown-item" (click)='clone(element)'>
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                        stroke-width="2">
                        <rect x="9" y="9" width="13" height="13" rx="2" ry="2" />
                        <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" />
                      </svg>
                      {{ "clone" | transloco }}
                    </a>
                  </li>
                  }
                  <li>
                    <a class="dropdown-item bb-dropdown-item" (click)='openAddImage(element.id)'>
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                        stroke-width="2">
                        <rect x="3" y="3" width="18" height="18" rx="2" />
                        <circle cx="8.5" cy="8.5" r="1.5" />
                        <path d="M21 15l-5-5L5 21" />
                      </svg>
                      {{ "AddImage" | transloco }}
                    </a>
                  </li>
                  @if(!isSubAdmin) {
                  <li>
                    <a class="dropdown-item bb-dropdown-item" (click)='edit(element)'>
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                        stroke-width="2">
                        <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
                        <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
                      </svg>
                      {{ "Edit" | transloco }}
                    </a>
                  </li>
                  @if(canChangeQuantity) {
                  <li>
                    <a class="dropdown-item bb-dropdown-item" (click)='changeQuantity(element.id)'>
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                        stroke-width="2">
                        <line x1="12" y1="5" x2="12" y2="19" />
                        <line x1="5" y1="12" x2="19" y2="12" />
                      </svg>
                      {{ "change Quantity" | transloco }}
                    </a>
                  </li>
                  }
                  <li>
                    <hr class="dropdown-divider">
                  </li>
                  <li>
                    <a class="dropdown-item bb-dropdown-item text-danger" (click)='deleteitem(element.id)'>
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                        stroke-width="2">
                        <path d="M3 6h18M19 6v14a2 2 0 01-2 2H7a2 2 0 01-2-2V6m3 0V4a2 2 0 012-2h4a2 2 0 012 2v2" />
                      </svg>
                      {{ "Delete" | transloco }}
                    </a>
                  </li>
                  }
                  }
                </ul>
              </div>
              }
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns" class="mat-header-row-custom"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="mat-row-custom"></tr>
        </table>
      </div>

      @if(!isStockTaking) {
      <mat-paginator *ngIf="!noData" class="bb-paginator" [length]="stockTotal" [pageSize]="10"
        (page)="onPaginateChange($event)">
      </mat-paginator>
      }
    </div>

    @if (noData) {
    <div class="bb-empty-state">
      <app-nodata></app-nodata>
    </div>
    }
  </div>
</div>

<!-- Quantity Update Popup -->
<div *ngIf="showRejectPopUp" class="bb-modal-backdrop popup">
  <div class="bb-modal-card bb-modal-sm popup-box">
    <div class="bb-grid bb-gap-16">
      <div class="bb-field">
        <label class="bb-label" for="quantity">{{ "quantity" | transloco }}</label>
        <input class="bb-input" type="number" id="quantity" [(ngModel)]="quantity" min="0" step="1"
          placeholder="{{ 'quantity' | transloco }}" />
      </div>
    </div>

    <div class="bb-modal-actions">
      <button (click)="onSubmit()" type="submit" class="bb-btn bb-btn-primary">
        {{ "Submit" | transloco }}
      </button>
      <button (click)='close()' class="bb-btn bb-btn-secondary"> {{ "close" | transloco }} </button>
    </div>
  </div>
</div>

<!-- Add Image Popup -->
<div *ngIf="addImage" class="bb-modal-backdrop popup">
  <div class="bb-modal-card popup-box">
    <div class="bb-grid bb-gap-16">
      <div class="bb-field">
        <label class="bb-label">{{ "image" | transloco }}</label>

        <div class="bb-upload-card">
          <input type="file" accept="image/*" (change)="onImageSelected($event)" #fileInput hidden />

          <div class="bb-upload-area" (click)="fileInput.click()">

            <!-- Placeholder -->
            <div *ngIf="!imagePreview" class="bb-upload-placeholder">
              <span class="bb-upload-icon">
                <svg width="26" height="26" viewBox="0 0 24 24" fill="none">
                  <rect x="3" y="7" width="18" height="14" rx="3" stroke="currentColor" stroke-width="2.5" />
                  <circle cx="12" cy="14" r="3.5" stroke="currentColor" stroke-width="2.5" />
                  <path d="M8 7L9.5 5H14.5L16 7" stroke="currentColor" stroke-width="2.5" />
                </svg>
              </span>

              <p class="bb-upload-title">
                {{ "upload image" | transloco }}
              </p>

              <small class="bb-upload-sub">
                {{ 'PNG / JPG' | transloco }}
              </small>
            </div>

            <!-- Preview -->
            <div *ngIf="imagePreview" class="bb-preview-container">
              <img [src]="imagePreview" class="bb-preview-img" />

              <button type="button" class="bb-btn bb-btn-secondary bb-btn-sm"
                (click)="fileInput.click(); $event.stopPropagation()" [disabled]="isUploadingImage">
                {{ "change image" | transloco }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="bb-modal-actions">
      <button type="button" class="bb-btn bb-btn-primary" (click)="submitImage()"
        [disabled]="!selectedImageFile || isUploadingImage">
        <span *ngIf="!isUploadingImage">{{ "Submit" | transloco }}</span>
        <span *ngIf="isUploadingImage">{{ "Uploading..." | transloco }}</span>
      </button>

      <button type="button" (click)="close()" class="bb-btn bb-btn-secondary" [disabled]="isUploadingImage">
        {{ "close" | transloco }}
      </button>
    </div>
  </div>
</div>

<!-- Cart Popup -->
<div *ngIf="cartPopUp" class="bb-modal-backdrop popup">
  <div class="bb-modal-card popup-content">
    <div class="bb-modal-header">
      <h4>{{ "Cart" | transloco }}</h4>
    </div>

    <div class="bb-cart-list">
      <div *ngFor="let item of cartItems" class="bb-cart-item">
        <span>{{ isAr ? item.name_ar : item.name_en }}</span>
        <button class="bb-icon-btn bb-icon-btn-danger" (click)="removeFromCart(item)">
          <i class="fa-solid fa-trash"></i>
        </button>
      </div>
    </div>

    <div class="bb-modal-actions">
      <button class="bb-btn bb-btn-primary" (click)="quickOrder()">
        {{ 'proceed to add order' | transloco }}
      </button>

      <button class="bb-btn bb-btn-primary" routerLink="/myclients.mobile">
        {{ "myclients" | transloco }}
      </button>
      <button (click)='close()' class="bb-btn bb-btn-secondary"> {{ "close" | transloco }} </button>
    </div>
  </div>
</div>
